"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sessionState_1 = require("./types/sessionState");
const settings_1 = require("./settings");
const redirectUtils_1 = require("../shared/redirectUtils");
const clearState = (authSession, userState) => {
    if (authSession) {
        if (userState === sessionState_1.SessionStateType.NotAuthenticated) {
            authSession.clearState();
        }
        else if (userState === sessionState_1.SessionStateType.Expired) {
            authSession.clearStateWithNotifyChanges();
        }
    }
};
const setState = (authSession, tokenExpiresAt) => {
    if (authSession && tokenExpiresAt) {
        authSession.setState(tokenExpiresAt);
    }
};
const logError = (message, error) => {
    if (window.newrelic && typeof window.newrelic.noticeError === 'function') {
        window.newrelic.noticeError(new Error(message), {
            logLevel: 'error',
            serviceName: 'ilc-plugin-transition-hooks',
            detailsJson: JSON.stringify(error),
        });
    }
    // eslint-disable-next-line no-console
    console.error('Error in ILC transition hooks plugin:', message, error);
};
const handleAuthTransition = (transition, loginPath, brandId) => {
    let navigationResult = { type: 'continue' };
    let authSession;
    if (window.deps && window.deps.authSession && window.deps.authSession.default) {
        authSession = window.deps.authSession.default;
    }
    let userState = sessionState_1.SessionStateType.NotAuthenticated;
    if (authSession) {
        userState = authSession.getState();
        clearState(authSession, userState);
    }
    if (transition.route.meta.protected === true || transition.prevRoute.meta.protected === true) {
        if (userState === sessionState_1.SessionStateType.Authenticated) {
            navigationResult = { type: 'continue' };
        }
        else if (!transition.prevRoute.meta.protected) {
            navigationResult = { type: 'stop-navigation' };
            window.System.import('@sharedLibrary/authSdk').then((lib) => {
                const sdk = lib.default;
                sdk.openLoginPopup(undefined, {
                    brandId: brandId,
                    onSignIn: (userInfo) => {
                        setState(authSession, Number(userInfo.tokenExpiresAt) || 0);
                        transition.navigate(transition.route.url);
                    },
                    onSignUp: (userInfo) => {
                        setState(authSession, Number(userInfo.tokenExpiresAt) || 0);
                        transition.navigate(transition.route.url);
                    },
                    onClose: () => {
                        userState = authSession ? authSession.getState() : userState;
                        if (userState === sessionState_1.SessionStateType.Authenticated) {
                            transition.navigate(transition.route.url);
                        }
                    },
                });
                return null;
            }).catch((error) => {
                logError('An error occurred on opening login popup', error);
            });
        }
        else if (transition.route.meta.protected) {
            const absoluteUrl = new URL(transition.route.url, window.location.origin);
            const routeUrl = absoluteUrl.pathname.concat(absoluteUrl.pathname.endsWith('/') ? '' : '/');
            if (routeUrl.indexOf(loginPath) !== 0) {
                navigationResult = {
                    type: 'redirect',
                    newLocation: `${loginPath}?${settings_1.settings.returnUrlParam}=${encodeURIComponent(transition.route.url)}`,
                };
            }
        }
    }
    return navigationResult;
};
const handleRedirectTransition = (transition) => ({
    type: 'redirect',
    newLocation: (0, redirectUtils_1.getNewLocation)(transition.route),
});
const getPageTransitionResult = (transition) => {
    if (transition.route.meta.redirect) {
        return handleRedirectTransition(transition);
    }
    const currentDomainSettings = settings_1.domainSettings.find((domain) => domain.hostName === transition.route.hostname);
    if (currentDomainSettings) {
        return handleAuthTransition(transition, currentDomainSettings.loginPath, currentDomainSettings.brandId);
    }
    return { type: 'continue' };
};
const plugin = {
    type: 'transitionHooks',
    getTransitionHooks: () => [
        ({ route, prevRoute, navigate }) => {
            const transitionResult = getPageTransitionResult({ route, prevRoute, navigate });
            return transitionResult;
        },
    ],
};
exports.default = plugin;
